import api from '@/apis'
import { createLatestOnly } from '@/utils/latestOnly'

// Re-dispatched after every write on this screen, so two can be in flight with the SAME
// parameters and DIFFERENT data — which is why 'takes no parameters' is not an exemption.
const rate_request = createLatestOnly()

export default {
  state: {
    rate: null
  },
  mutations: {
    UPDATE_EXCHANGE_RATE(state, payload) {
      state.rate = payload
    }
  },
  actions: {
    async fetchExchangeRate({ commit }) {
      const isLatest = rate_request()
      try {
        const response = await api.getExchangeRate()
        // A newer request of this kind owns the view now — see utils/latestOnly.js.
        if (!isLatest()) return
        if (response.data.success) {
          const { exchange_rate } = response.data.data
          commit('UPDATE_EXCHANGE_RATE', exchange_rate)
        } else throw Error()
      } catch (error) {
        if (!isLatest()) return
        commit('SET_SNACKBAR', { status: true, color: 'error', text: 'Server Occur Error', icon: 'close', timeout: '2000' })
      }
    },
    async updateExchangeRate({ state, commit }) {
      // SHARES the read's token, which is the other half of the data-currency rule: this screen
      // holds a SINGLE value, so an accepted write replaces the whole view and claiming makes it
      // the newest request by construction — no read of this kind can commit over it. (A per-row
      // ledger would be the wrong shape here: there are no rows.)
      const isLatest = rate_request()
      try {
        const params = { exchange_rate: state.rate }
        const response = await api.updateExchangeRate({ params })
        if (!isLatest()) return
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: 'Update Exchange Rate Success', icon: 'check', timeout: '2000' })
        } else throw Error()
      } catch (error) {
        if (!isLatest()) return
        commit('SET_SNACKBAR', { status: true, color: 'error', text: 'Server Occur Error', icon: 'close', timeout: '2000' })
      }
    }
  }
}
